import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import api from "@app/analytics/MeetingReport/api";

const useHighlightsQuery = (
  { enabled }: { enabled: boolean } = { enabled: true }
) => {
  const { sessionId } = useParams();

  return useQuery({
    queryKey: ["highlights", sessionId],
    queryFn: () => api.data.getSessionHighlights(sessionId!),
    refetchOnWindowFocus: false,
    enabled,
    refetchOnMount: false,
  });
};

export default useHighlightsQuery;
